import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';
import LoginBySocialMediaQuery from './LoginBySocialMediaQuery';

const LoginBySocialMediaConnectorApollo = ({ children }) => {
  const { loading, error, data } = useQuery(LoginBySocialMediaQuery);

  let result = {
    loading,
    error,
  };

  if (!loading) {
    result.isAbleToLoginWithFacebook = data.me.isAbleToLoginWithFacebook;
    result.isAbleToLoginWithGoogle = data.me.isAbleToLoginWithGoogle;
    result.isAbleToLoginWithApple = data.me.isAbleToLoginWithApple;
  }

  return children(result);
};

LoginBySocialMediaConnectorApollo.propTypes = {
  children: PropTypes.func.isRequired,
};

export default LoginBySocialMediaConnectorApollo;
